<!--
 * @Author: huangyh
 * @Date: 2021-03-12 11:33:41
 * @LastEditors: huangyh
 * @LastEditTime: 2021-04-01 10:42:37
-->
<template>
  <div class="smy__card-full-box">
    <Card :bordered="false" class="smy__card-full">
      <p slot="title">问卷列表</p>
      <div class="search">
        <div>
          <div class="search-detail" :class="{ 'search-detail-close': !searchVisible }" :style="{ overflow: !searchVisible ? 'hidden' : '' }">
            <div class="search-detail-item">
              <Input class="search-input" placeholder="请输入问卷标题" v-model="searchForm.theme"></Input>
            </div>
            <div class="search-detail-item">
              <Button type="primary" class="search-button" @click=";(pageIndex = 0), loadList()">查找</Button>
              <Button class="search-button" @click="resetSearchForm">重置</Button>
            </div>
            <div class="sp">
              <Button type="primary" class="search-button" @click="add">新增问卷</Button>
            </div>
          </div>
        </div>
      </div>
      <!-- 工单列表 -->
      <div class="table">
        <Table stripe ref="table" :loading="listLoading" :columns="columns" :data="list"></Table>
      </div>
      <!-- 分页控件 -->
      <Page
        show-total
        show-sizer
        class="page"
        placement="top"
        :current="pageIndex + 1"
        :total="count"
        :page-size-opts="pageSizeOpts"
        @on-change="pageIndexChange"
        @on-page-size-change="pageSizeChange"
      ></Page>
    </Card>
    <Modal title="新建问卷" v-model="showCreateModel" :mask-closable="false" :closable="false" class-name="allCenter">
      <Form :model="form" ref="form" :label-width="80" :rules="ruleValidate">
        <FormItem label="问卷标题" prop="theme">
          <Input v-model="form.theme" placeholder="问卷标题"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="closeAdd">取消</Button>
        <Button type="primary" :loading="submitIng" @click="handleAddSubmit">创建</Button>
      </div>
    </Modal>
    <Modal title="链接" v-model="showLink" :mask-closable="false" :closable="false" class-name="allCenter" @on-ok="confirmCopy" ok-text="复制链接">
      <div id="link">{{ link }}</div>
    </Modal>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      searchVisible: true, // 是否显示详细筛选条件
      pageSize: 10,
      pageIndex: 0,
      listLoading: false, // 表格加载状态
      count: 0,
      list: [],
      searchForm: {
        theme: '',
      },
      showCreateModel: false,
      form: {
        theme: '',
      },
      ruleValidate: {
        theme: [
          {
            required: true,
            message: '请填写问卷标题',
            trigger: 'blur',
          },
        ],
      },
      submitIng: false,
      // 链接
      showLink: false,
      link: '',
    }
  },
  computed: {
    ...mapState('table', ['pageSizeOpts']),
    columns() {
      const allColumns = [
        {
          title: '标题',
          key: 'theme',
        },
        {
          title: '状态',
          key: 'collect_state',
          render: (h, { row }) => {
            if (row.collect_state === 1) return '收集中'
            if (row.collect_state === 2) return '已停止'
            return ''
          },
        },
        {
          title: '答题人数',
          key: 'answers_num',
        },
        {
          title: '创建时间',
          key: 'create_time',
        },
        {
          title: '创建人',
          key: 'user_name',
        },
        {
          title: '操作',
          key: '',
          render: (h, { row }) => {
            const button = [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                  },
                  nativeOn: {
                    click: () =>
                      this.edit({
                        surveyId: row.id,
                        nodeTmplId: row.fk_t_bo_service_node_tmpl_id,
                      }),
                  },
                  style: {
                    margin: '5px 0',
                    marginRight: '10px',
                  },
                },
                '编辑'
              ),
              h(
                'Button',
                {
                  nativeOn: {
                    click: () => this.copyLink({ link: row.link }),
                  },
                  style: {
                    margin: '5px 0',
                    marginRight: '10px',
                  },
                },
                '链接'
              ),
              h(
                'Button',
                {
                  nativeOn: {
                    click: () =>
                      this.statistics({
                        surveyId: row.id,
                        nodeTmplId: row.fk_t_bo_service_node_tmpl_id,
                      }),
                  },
                  style: {
                    margin: '5px 0',
                    marginRight: '10px',
                  },
                },
                '报表'
              ),
              h(
                'Button',
                {
                  nativeOn: {
                    click: () =>
                      this.$router.push({
                        path: '/answer',
                        query: {
                          id: row.id,
                        },
                      }),
                  },
                  style: {
                    margin: '5px 0',
                    marginRight: '10px',
                  },
                },
                '数据'
              ),
              h(
                'Button',
                {
                  props: {
                    disabled: row.collect_state === 2,
                  },
                  nativeOn: {
                    click: () => this.stop({ surveyId: row.id }),
                  },
                  style: {
                    margin: '5px 0',
                    marginRight: '10px',
                  },
                },
                '停止'
              ),
              h(
                'Button',
                {
                  nativeOn: {
                    click: () => this.delQuestion({ id: row.id }),
                  },
                  style: {
                    margin: '5px 0',
                    marginRight: '10px',
                  },
                },
                '删除'
              ),
            ]
            return h('div', button)
          },
        },
      ]
      allColumns.forEach((v) => (v.align = 'center'))
      return allColumns
    },
  },
  mounted() {
    this.loadList()
  },
  methods: {
    // 加载列表数据
    loadList() {
      this.listLoading = true
      this.$http
        .all([
          this.$http.get('/survey/list', {
            params: {
              pageIndex: this.pageIndex,
              pageSize: this.pageSize,
              ...this.searchForm,
            },
          }),

          this.$http.get('/survey/count', {
            params: this.searchForm,
          }),
        ])
        .then(
          this.$http.spread((res1, res2) => {
            this.list = res1.data
            this.count = res2.data
            this.listLoading = false
          })
        )
    },
    // 分页 每页大小 改变回调
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.loadList()
    },
    // 分页 页码 改变回调
    pageIndexChange(pageIndex) {
      this.pageIndex = pageIndex - 1
      this.loadList()
    },
    // 重置搜索框
    resetSearchForm() {
      this.searchForm = {
        theme: '',
      }
      this.loadList()
    },
    // 新增问卷
    add() {
      this.showCreateModel = true
      this.$nextTick(() => {
        this.$refs['form'].resetFields()
      })
    },
    handleAddSubmit() {
      this.submitIng = true
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$http
            .post('/survey/save', {
              ...this.form,
            })
            .then((res) => {
              this.submitIng = false
              this.showCreateModel = false
              this.loadList()
              this.$Message.success('创建成功!')
            })
        } else {
          this.submitIng = false
          this.$Message.error('请检查表单完整')
        }
      })
    },
    closeAdd() {
      this.showCreateModel = false
      this.form = {
        title: '',
        link: '',
      }
    },
    // 编辑
    edit({ surveyId, nodeTmplId }) {
      this.$router.push({
        path: '/questionInfo',
        query: {
          surveyId,
          nodeTmplId,
        },
      })
    },
    // 删除
    delQuestion({ id }) {
      this.$Modal.confirm({
        title: '注意',
        content: '确认删除此数据？',
        onOk: () => {
          this.$http
            .delete('/survey/del', {
              params: {
                id,
              },
            })
            .then((res) => {
              if (res.success) {
                this.$Message.success('删除成功')
                this.loadList()
              }
            })
        },
        onCancel: () => {},
      })
    },
    // 链接
    copyLink({ link }) {
      this.link = link
      this.showLink = true
    },
    confirmCopy() {
      let ele = document.getElementById('link')
      const selection = window.getSelection() // 获取选中区域对象

      if (ele.nodeName === 'INPUT' || ele.nodeName === 'TEXTAREA') {
        ele.select() // 此时ele被选中
        ele.setSelectionRange(0, ele.value.length)
      } else {
        selection.removeAllRanges() // 清空选中的区域
        const range = document.createRange() // 新建区域
        range.selectNodeContents(ele) // 将目标节点添加置range
        selection.addRange(range) // 往选区中添加新建的区域，此时ele被选中
      }

      document.execCommand('copy') // 执行复制命令
      selection.removeAllRanges() // 此时ele恢复未选中状态
      this.$Message.success('链接已复制到粘贴板')
    },
    // 数据报表
    statistics({ surveyId, nodeTmplId }) {
      this.$router.push({
        path: '/questionnaireStatistics',
        query: {
          surveyId,
          nodeTmplId,
        },
      })
    },
    // 停止问卷
    stop({ surveyId }) {
      this.$Modal.confirm({
        title: '注意',
        content: '确认停止收集此问卷？',
        onOk: () => {
          this.$http
            .post('/survey/stop', {
              surveyId,
            })
            .then((res) => {
              if (res.success) {
                this.$Message.success('停止成功')
                this.loadList()
              }
            })
        },
        onCancel: () => {},
      })
    },
  },
}
</script>
<style lang="less" scoped>
.search {
  margin-bottom: 16px;
  .sp {
    width: 100%;
    text-align: right;
  }
  .search-top {
    display: flex;
    justify-content: space-between;

    .search-top-left {
      display: flex;
      width: 70%;

      .search-input {
        width: 80%;

        // margin-left: 10px;
      }

      .search-button {
        margin-left: 10px;
      }
    }

    .search-top-right {
      .filter-column {
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }

      .search-button {
        margin-left: 6px;
      }
    }
  }

  .search-detail {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
    // height: 90px;
    transition: 0.5s;

    .search-detail-item {
      width: 24.25%;

      .search-input {
        width: 100%;
        margin-bottom: 10px;
      }

      .search-button {
        margin-right: 6px;
        margin-bottom: 10px;
      }
    }

    .search-detail-item:nth-child(2n + 1),
    .search-detail-item:nth-child(4n + 2) {
      margin-right: 1%;
    }
  }

  .search-detail-close {
    height: 0;
    opacity: 0;
  }
}

.page {
  margin-top: 20px;
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/questionnaire/questionnaireList/index.vue